"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.SurveyPopup = exports.PrimaryButton = exports.Hero = exports.Description = exports.CloseButton = exports.Body = exports.Actions = void 0;
const reactjs_popup_1 = __importDefault(require("reactjs-popup"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const Button_style_1 = require("../../../atoms/Button/Button.style");
const SurveyPopup = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;

  &-overlay {
    z-index: 1100;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &-content {
    background-color: ${colors_1.white};
    opacity: 1;
    border-radius: 16px;
    position: relative;
    padding: 0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    max-width: 520px;
    width: 90vw;
    margin: 0;
    overflow: hidden;

    @media ${media_1.media.mobile} {
      margin: 1rem;
      width: calc(100vw - 2rem);
    }
  }
`;
exports.SurveyPopup = SurveyPopup;
const Hero = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media ${media_1.media.mobile} {
    height: 160px;
  }
`;
exports.Hero = Hero;
const CloseButton = styled_components_1.default.button `
  position: absolute;
  top: 1rem;
  right: 1rem;
  border: none;
  background-color: ${colors_1.white};
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  &:hover {
    background-color: ${colors_1.gray100};
  }

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
`;
exports.CloseButton = CloseButton;
const Body = styled_components_1.default.div `
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  @media ${media_1.media.mobile} {
    padding: 1.5rem;
  }
`;
exports.Body = Body;
const Title = styled_components_1.default.h2 `
  color: ${colors_1.acBlue};
  font-size: 2.4rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;

  @media ${media_1.media.mobile} {
    font-size: 2rem;
  }
`;
exports.Title = Title;
const Description = styled_components_1.default.p `
  color: ${colors_1.gray400};
  font-size: 1.6rem;
  line-height: 1.5;
  margin: 0;

  @media ${media_1.media.mobile} {
    font-size: 1.5rem;
  }
`;
exports.Description = Description;
const Actions = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${colors_1.gray100};

  @media ${media_1.media.mobile} {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 0.5rem;
  }
`;
exports.Actions = Actions;
const PrimaryButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: ${colors_1.cta};
  color: ${colors_1.gray400};
  font-weight: 700;
  border: none;
  padding: 1.1rem 2.2rem;
  border-radius: 8px;
  font-size: 1.6rem;
  cursor: pointer;
  transition: filter 0.2s, transform 0.1s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(0.95);
  }

  &:active {
    transform: scale(0.98);
  }
`;
exports.PrimaryButton = PrimaryButton;
